"use strict";

/**
 * Implements code selection on double click.
 */
export default class CodeDoubleclick {
	constructor( element ) {
		var self = this;
		this.element = element;
		element.addEventListener( 'dblclick', this.handleClick.bind( this ) );
	};

	handleClick() {
		window.getSelection().selectAllChildren( this.element );
	};
}
